module.exports = __webpack_public_path__ + "static/Recommendation-841a617d2173fb996dc04b14751db665.png";